const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaMotorista: [],
    listaTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'MOTORISTA_DOCUMENTO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'MOTORISTA_DOCUMENTO_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'MOTORISTA_DOCUMENTO_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaMotorista: action.payload.data
            };

        case 'MOTORISTA_DOCUMENTO_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
            };
                      
        default:
            return state;
    }
}
